module.exports = __webpack_public_path__ + "50252548c6a673b3cbd156f7ce8dc7a5.jpg";